const getRootStyle = ( value, fallback ) => {

  if( ! value || ! fallback ) return null

  const style = getComputedStyle(document.body)
  const color = style.getPropertyValue(value) 
  ? style.getPropertyValue(value) 
  : style.getPropertyValue(fallback)
    ? style.getPropertyValue(fallback)
    : '#ffffff'

  return color
}

const addManageBillingModalId = ( teamId = 0 ) => {
  return `msync-org-manage-billing-modal-${teamId}`
}

const getPaletteColor = ( type='primary-btn' ) => {

  switch (type) {
    case 'primary':
      return getRootStyle( '--global-palette1', '--primary-color' )
    case 'primary-btn':
      return getRootStyle( '--global-palette1', '--primary-color-btn' )
    case 'primary-btn-dark':
      return getRootStyle( '--global-palette2', '--primary-color-btn-dark' )
    case 'font-color':
      return getRootStyle( '--global-palette9', '--white' )
    default:
      return '#ffffff'
  }
}

export{
  getPaletteColor,
  addManageBillingModalId
}
